import { Card, Divider, Skeleton } from '@fleet/webshop-ui';

const NewPasswordFormSkeleton = () => {
  return (
    <Card className="flex flex-col gap-4 rounded-xl">
      {/* Heading */}
      <Skeleton className="h-6 w-48" />

      {/* Description text */}
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-3/4" />

      <Divider />

      {/* Password field */}
      <div className="flex flex-col gap-2">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-12 w-full rounded-md" />
      </div>

      {/* Repeat password field */}
      <div className="flex flex-col gap-2">
        <Skeleton className="h-4 w-36" />
        <Skeleton className="h-12 w-full rounded-md" />
      </div>

      {/* Submit button */}
      <Skeleton className="h-12 w-full rounded-md" />
    </Card>
  );
};

export default NewPasswordFormSkeleton;
